export default __webpack_public_path__ + "static/media/phoneIcon.8f9945cb.svg";